// extracted by mini-css-extract-plugin
export var searchBox = "suche-module--search-box--1YNPM";
export var illustration = "suche-module--illustration--2sQ_K";
export var spinAround = "suche-module--spinAround--1yF6m";